'use strict';

angular.module('shiftTraderApp')
    .controller('AvailabilityManagementViewRequestCtrl', function($scope, AvailabilityRules, TimeService,
                                                       $state, $stateParams, $location,
                                                       SAErrorHandler, me, org,
                                                       Session, AvailabilityChangeRequests,
                                                       availability_change_request) {
      $scope.me = me;
      $scope.org = org;
      $scope.availabilityChangeRequest = availability_change_request;

      var calcRequestStats = function() {
        $scope.availabilityChangeRequest.$calcStats();

        $scope.availabilityChangeRequest.user_availability_change_requests =
          _.sortBy($scope.availabilityChangeRequest.user_availability_change_requests, function(uacr) {
            if (uacr.$hasBeenRespondedTo()) {
              if (uacr.$hasPendingAvailabilitySet()) {
                return 'Working on it';
              } else if (uacr.$hasInReviewAvailabilitySet()) {
                return 0;
              } else if (uacr.$hasApprovedAvailabilitySet()) {
                return 4;
              } else {
                return 1;
              }

            } else {
              // user has not replied
              return 2;
            }
          });
      };

      calcRequestStats();

      $scope.allDepartments = $scope.org.departments;

      $scope.nowDate = TimeService.getNowInStoreTime();
      $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc($stateParams.date)).startOf('month');
      $scope.workDayStartHour = Session.getWorkDayStartHour();

      $scope.state = {
      };

    $scope.placeholder = 'Next semester is right around the corner! Please submit your new availability. We typically have a hard time scheduling Tuesday morning so any help is appreciated!';

    $scope.$on('sa:availabilityManagementViewRequest:updateStats', function() {
      console.log('sa:availabilityManagementViewRequest:updateStats');
      calcRequestStats();
    });

});
